import React from "react"
import freeEbook from "../images/freeEbook.png"

function EBook() {
  return (
    <div className="ebook-container">
      <img
        src={freeEbook}
        alt="Foto do ebook"
        className="ebook-image sm:w-[350px] w-[280px] md:w-[380px] lg:w-[400px] self-center transition-transform duration-300 hover:scale-105"
      />
    </div>
  )
}

export default EBook
